<template>
  <div class="info-page">
    <crumbs title="零部件加工企业填报" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="企业名称" prop="companyName">
              <el-input
                v-model="form.companyName"
                placeholder="请输入企业名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="所属地区" prop="regionAddress">
              <region
                v-model="form.regionAddress"
                placeholder="请选择所属地区"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="办公地址" prop="companyAdress">
              <el-input
                v-model="form.companyAdress"
                placeholder="请输入办公地址"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="加工中心地址" prop="processAdress">
              <el-input
                v-model="form.processAdress"
                placeholder="请输入加工中心地址"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="企业规模" prop="companyScale">
              <el-input
                v-model="form.companyScale"
                placeholder="请输入企业规模描述，如收入、订单等"
                maxlength="500"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              label="企业简介"
              prop="companyIntroduction"
              class="no-label"
            >
              <el-input
                v-model="form.companyIntroduction"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入企业简介"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              label="企业需求"
              prop="companyRequire"
              class="no-label"
            >
              <el-input
                v-model="form.companyRequire"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入企业需求"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="是否在前台展示" prop="isShow">
              <el-switch v-model="form.isShow"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>加工能力</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="加工设备" prop="processEquipment">
              <el-input
                v-model="form.processEquipment"
                placeholder="请输入加工设备"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="加工精度" prop="processAccuracy">
              <el-input
                v-model="form.processAccuracy"
                placeholder="请输入加工精度"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="加工周期" prop="processCycle">
              <el-input
                v-model="form.processCycle"
                placeholder="请输入加工周期"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              label="可分配给机器人加工的资源和能力"
              prop="canAllocation"
              class="spe"
            >
              <el-input
                v-model="form.canAllocation"
                placeholder="请输入可分配给机器人加工的资源和能力"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="已服务的客户" prop="customersServed">
              <el-input
                v-model="form.customersServed"
                placeholder="请输入已服务的客户"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="其他" prop="processOther">
              <el-input
                v-model="form.processOther"
                placeholder="请输入其他"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>主要负责人</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="姓名" prop="principalName">
              <el-input
                v-model="form.principalName"
                placeholder="请输入姓名"
                maxlength="15"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职务" prop="principalPosition">
              <el-input
                v-model="form.principalPosition"
                placeholder="请输入职务"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="联系方式" prop="principalContactWay">
              <el-input
                v-model="form.principalContactWay"
                placeholder="请填写手机或固定座机 如：010-87654321"
                maxlength="13"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>联系人</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="姓名" prop="contactName">
              <el-input
                v-model="form.contactName"
                placeholder="请输入姓名"
                maxlength="15"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职务" prop="contactPosition">
              <el-input
                v-model="form.contactPosition"
                placeholder="请输入职务"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="联系方式" prop="contactContactWay">
              <el-input
                v-model="form.contactContactWay"
                placeholder="请填写手机或固定座机 如：010-87654321"
                maxlength="13"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="contactEmail">
              <el-input
                v-model="form.contactEmail"
                placeholder="请输入邮箱"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
import CheckObj from "@/utils/check.js";
export default {
  name: "machiningComponentInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        companyName: "",
        regionAddress: [],
        companyAdress: "",
        processAdress: "",
        companyScale: "",
        companyIntroduction: "",
        companyRequire: "",
        // 加工能力
        processEquipment: "",
        processAccuracy: "",
        processCycle: "",
        canAllocation: "",
        customersServed: "",
        processOther: "",
        // 主要负责人
        principalName: "",
        principalPosition: "",
        principalContactWay: "",
        // 联系人
        contactName: "",
        contactPosition: "",
        contactContactWay: "",
        contactEmail: "",
        isShow: false
      },
      rules: {
        companyName: [isEmpty("请输入企业名称")],
        regionAddress: [isEmpty("请选择所属地区", "change")],
        companyAdress: [isEmpty("请输入办公地址")],
        processAdress: [isEmpty("请输入加工中心地址")],
        companyScale: [isEmpty("请输入企业规模")],
        companyIntroduction: [isEmpty("请输入企业简介")],
        companyRequire: [isEmpty("请输入企业需求")],
        processEquipment: [isEmpty("请输入加工设备")],
        processAccuracy: [isEmpty("请输入加工精度")],
        processCycle: [isEmpty("请输入加工周期")],
        canAllocation: [isEmpty("请输入可分配给机器人加工的资源和能力")],
        customersServed: [isEmpty("请输入已服务的客户")],
        processOther: [isEmpty("请输入其他")],
        principalName: [
          isEmpty("请输入姓名"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请输入正确的中文姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        principalPosition: [isEmpty("请输入职务")],
        principalContactWay: [
          isEmpty("请输入联系方式"),
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !CheckObj.checkPhone(value) &&
                !CheckObj.checkTelephone(value)
              ) {
                return callback(new Error("请输入正确的电话号码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        contactName: [
          isEmpty("请输入姓名"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请输入正确的中文姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        contactPosition: [isEmpty("请输入职务")],
        contactContactWay: [
          isEmpty("请输入联系方式"),
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !CheckObj.checkPhone(value) &&
                !CheckObj.checkTelephone(value)
              ) {
                return callback(new Error("请输入正确的电话号码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        contactEmail: [
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkEmail(value)) {
                return callback(new Error("请输入正确的邮箱"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        isShow: [isEmpty("请选择是否在前台展示", "change")]
      }
    };
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        regionAddress,
        ...others
      } = this.form;
      // 处理 regionAddress
      const [provinceCode = "", cityCode = "", districtCode = ""] =
        regionAddress;
      return {
        ...others,
        provinceCode,
        cityCode,
        districtCode
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        provinceCode = "",
        cityCode = "",
        districtCode = "",
        ...others
      } = data;
      return {
        ...others,
        regionAddress: [provinceCode, cityCode, districtCode]
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("machining", "addComponent", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("machining", "addComponent", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("machining", "getComponentInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/policyManage/projectMessageList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
